var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1058.12,
    y1: 472.27,
    x2: 881.25,
    y2: 219.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1631.57,
    y1: 381.53,
    x2: 1423.12,
    y2: 201.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 517.88,
    y1: 212.29,
    x2: -458.86,
    y2: 77.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#88c532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#517844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2f484f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 427.95,
    y1: 442.28,
    x2: 205.47,
    y2: 85.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 802.27,
    y1: 177.13,
    x2: 361.7,
    y2: -69.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1423.59,
    y1: 203.71,
    x2: 1035.01,
    y2: -121.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1906.04,
    y1: 295.77,
    x2: 1643.33,
    y2: -241.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2011.46,
    y1: 927.49,
    x2: -135.24,
    y2: 760.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1760.68,
    y1: 818.06,
    x2: 120.29,
    y2: 678.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2436.63,
    y1: 1088.42,
    x2: -527.03,
    y2: -222.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1957.41,
    y1: 811.07,
    x2: 1247.97,
    y2: 624.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1981.5,
    y1: 845.7,
    x2: -6.06,
    y2: 719.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1c2538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 547.45,
    y1: 537.92,
    x2: 390.88,
    y2: 332.64,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1224.85,
    y1: 455.66,
    x2: 897.17,
    y2: 179.93,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1647.33,
    y1: 602.95,
    x2: 1417.07,
    y2: 372.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 748.36,
    y1: 638.19,
    x2: 123.68,
    y2: 638.19,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1721.41,
    y1: 1061.03,
    x2: 985.32,
    y2: 676.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1920.54,
    y1: 1194.14,
    x2: 646.6,
    y2: 967.28,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Blue_and_Green_Crown",
    "data-name": "Blue and Green Crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_125",
    "data-name": "Artwork 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_125-2",
    "data-name": "Artwork 125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M887.25,434.09s55.63,4.48,56.44-60.56c0,0,22.85-4.39,33.99,3.17,0,0-4.49,45.41,43.24,52.38,0,0-41.11,39.64-133.67,5.01Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.43,444.98s71.97,12.01,111.62-84.32c0,0,20.03-9.2,38.23,7.17,0,0-5.3,41.25-.54,46.33,0,0-78,81.48-149.31,30.81Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.8,351.67c-7.8,28.68-37.35,45.63-66.12,37.85-9.75-2.68-18.13-7.8-24.75-14.65-9.25-9.66-14.67-22.58-14.99-36.21-.09-5.04.52-10.12,1.89-15.27,7.38-27.21,34.38-43.85,61.58-38.82,1.53.23,2.98.57,4.54.97,17.56,4.77,30.75,17.78,36.56,33.67,3.58,10.13,4.32,21.32,1.29,32.45Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.39,369.12c-24.27,17.16-57.86,11.42-75.09-12.9-5.81-8.27-9.02-17.56-9.77-27.05-.98-13.34,3.06-26.75,11.48-37.46,3.14-3.94,6.84-7.48,11.18-10.57,23.01-16.29,54.43-11.93,72.2,9.26,1.03,1.15,1.94,2.34,2.89,3.64,10.5,14.85,12.4,33.29,6.77,49.24-3.69,10.09-10.24,19.19-19.66,25.84Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.25,446.33s-24.86,51.63-83.87,29.79c-13.39-4.99-24.12-9.67-32.71-13.99-29.34-14.65-34.01-24.67-34.01-24.67,0,0,16.25-46.76,1.82-93.31-.1-.43-.27-.82-.37-1.24l10.04-4.2,8.47-3.5s7.1,8.55,18.68,21.01c24.91,26.77,70.64,71.8,111.94,90.12Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.01,459.7l-16.93,49.86c-29.34-14.65-88.41-72.11-88.41-72.11,0,0,16.25-46.76,1.82-93.31l9.67-5.45,23.18-12.99-18.52,18.22s5.5,43.02,9.23,55.14c10.8,34.66,48.93,59.21,79.96,60.63Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,156.08c-.98,29.71-25.84,53.01-55.62,52.06-10.11-.36-19.44-3.41-27.46-8.55-11.22-7.27-19.47-18.59-22.93-31.78-1.25-4.88-1.83-9.97-1.68-15.29.92-28.18,23.36-50.59,50.98-51.96,1.54-.12,3.03-.14,4.64-.11,18.18.6,34.02,10.22,43.34,24.35,5.82,9.03,9.11,19.76,8.73,31.28Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.07,313.74c-7.74,28.7-37.26,45.71-66.04,37.99-9.76-2.66-18.15-7.76-24.78-14.59-9.27-9.64-14.72-22.55-15.07-36.17-.1-5.04.49-10.12,1.86-15.27,7.32-27.22,34.29-43.92,61.49-38.95,1.53.23,2.99.56,4.54.96,17.57,4.73,30.79,17.71,36.64,33.59,3.6,10.12,4.36,21.31,1.36,32.44Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.44,85.15c-7.8,28.68-37.35,45.63-66.12,37.85-9.75-2.68-18.13-7.8-24.75-14.65-9.25-9.66-14.67-22.58-14.99-36.21-.09-5.04.52-10.12,1.89-15.27,7.38-27.21,34.38-43.85,61.58-38.82,1.53.23,2.98.57,4.54.97,17.56,4.77,30.75,17.78,36.56,33.67,3.58,10.13,4.32,21.32,1.29,32.45Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.03,125.43c-16.58,24.67-50.01,31.25-74.76,14.66-8.38-5.66-14.68-13.2-18.75-21.81-5.66-12.12-6.66-26.09-2.59-39.1,1.53-4.8,3.73-9.42,6.69-13.85,15.71-23.41,46.62-30.51,70.77-17.03,1.37.71,2.65,1.49,3.99,2.37,15.1,10.15,23.43,26.7,23.84,43.62.15,10.74-2.75,21.58-9.18,31.15Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.03,167.64c-24.27,17.16-57.86,11.42-75.09-12.9-5.81-8.27-9.02-17.56-9.77-27.05-.98-13.34,3.06-26.75,11.48-37.46,3.14-3.94,6.84-7.48,11.18-10.57,23.01-16.29,54.43-11.93,72.2,9.26,1.03,1.15,1.94,2.34,2.89,3.64,10.5,14.85,12.4,33.29,6.77,49.24-3.69,10.09-10.24,19.19-19.66,25.84Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.91,966.81s-39.4,51.85,11.49,89.87c0,0,119.63-150.99,797.69-143.81,430.69,4.56,734.48,149.96,734.48,149.96,0,0,77.64-39.53,51.5-80.47,0,0-488.37-183.73-758.04-192.6-269.66-8.86-669.13,73.93-837.12,177.05Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,960.29s74.9-59.95,12.92-144.41c0,0,219.3-188.26,815.2-139.24,595.89,49.02,682.52,142.59,682.52,142.59,0,0-14.93,92.37,77.68,163.12,0,0-631.49-166.25-795.8-168.81-164.31-2.56-529.9,5.29-792.51,146.74Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.68,815.88s-46.47-26.08-29.85-69.55c0,0,77.58-139.59,818.51-115.24,740.93,24.35,729.96,149.99,729.96,149.99,0,0-15.78,48.18-42.44,53.19,0,0-291.41-140.59-701.02-146.65-497.12-7.36-710.49,95.63-775.16,128.26Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.55,490.24s-53.16,126.83-46.28,221.96c1.4,19.93,5.48,38.35,13.06,53.97-3.26-2.57-113.08-85.8-703.07-111.91-649.68-28.68-722.07,78.34-827.57,90.11,0,0,57.94-49.66,20.75-171.6,0,0-29.14-274.77-102.7-365.46,0,0,9.68-16.79,31.36-14.46,0,0,195.38,300.3,298.55,285.38,103.17-15.04,164.02-314.41,165.19-351.83,0,0,12.82-12.24,32.87-1.87,0,0,138.96,305.55,305.66,322.1,166.82,16.55,327.46-308.93,327.46-308.93,0,0,18.89-5.95,35.21,4.2,0,0,54.79,332.36,195.5,310.79,140.59-21.57,283.4-295.17,283.4-295.17,0,0,13.76-5.71,27.51,2.91,3.61,2.33,7.23,5.6,10.61,10.14,0,0-73.79,185.71-67.5,319.65Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.15,994.31s6.46,39.53,80.69,9.93c74.23-29.61,217.86-65.4,273.95-63.69,0,0-251.24,65.54-330.4,116.14,0,0-38.83-20.63-24.24-62.37Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.11,349.4s8.65,40.58,36.94,64.09c28.29,23.51,78.35,30.77,78.35,30.77,0,0-96.23-70.78-115.29-94.86Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.63,795.43s7.93-26.11-100.84-74.38c-120.07-53.28-273.14-93.49-273.14-93.49,0,0,74.26-7.34,227.67,34.86,39.29,10.84,83.82,24.95,133.6,43.25.58.23,1.28.47,1.86.7,0,0,48.61,60.15,10.84,89.06Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.02,859.02s328.43-167.11,789.71-134.42c461.28,32.69,695.92,175.97,695.92,175.97l-9.27-81.34s-386.04-155.22-757.24-162.35c-419.25-8.05-740.47,159-740.47,159l21.35,43.14Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,772.57s-52.75,11.96-46.68-11.27c8.64-33.04,170.31-85.83,283.11-117.19,0,0-141.98-14.55-321.74,91.82,0,0-21.28,10.82-10.98,40.82,2.68,7.8,7.18,14.86,12.51,21.16l15.22,17.99,214.39-82.52",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.11,995.3s388.73-188.27,792.88-155.33c404.15,32.93,812.59,173.87,812.59,173.87,0,0,24.6-22.12-13.7-40.6,0,0-493.66-155.63-774.46-169.65-280.8-14.02-600.03,52.14-791.94,151.41,0,0-27.32,21.11-25.37,40.31Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.63,568.46s74.33,73.3,164.32,30.49c101.24-48.17,97.03-131.7,97.03-131.7,0,0-25.15,65.8-112.97,107.65-51.48,24.53-148.37-6.44-148.37-6.44Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.12,551.03S148.32,226.51,123.57,194.22l-17.87,13.12s101.59,278.83,102.78,365.41l12.64-21.73Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.53,325.6s62.92,240.41,165.24,210.63c102.32-29.78,166.94-242.08,166.94-242.08,0,0-100.96,193.29-160.01,177.77-60.79-15.98-172.18-146.32-172.18-146.32Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.29,117.87s85,398.17,300.99,358.84c215.99-39.33,345.51-339.03,345.51-339.03,0,0-252.86,320.28-347.58,297.06-173.59-42.56-279.82-318.79-279.82-318.79l-19.09,1.93Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.99,141.96s39.88,346.16,180.21,320.42c140.34-25.73,329.05-304.74,329.05-304.74,0,0-13.32-7.71-30.29-.11,0,0-162.29,280.71-284.98,271.12-91.05-7.12-125.59-8.29-194-286.69Z",
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.74,941.39s35.23-51.81,25-74.71c0,0,246.05-106.53,354.75-120.77,0,0-184.02,9.46-384.47,113.11,0,0,8.13,56.32-34.26,101.27l38.98-18.89Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.17,581.39s60.85,52.41,136.51,31.47c76.51-21.17,85.32-67.2,102.91-102-29.16,57.72-69.33,68.2-114.9,83.91-35.31,12.18-71.82,11.26-124.52-13.39Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.34,797.93s286.1-99.13,399.25-116.87c0,0-174.89,25.31-277.62,58.41-102.74,33.1-155.01,15.92-117.01-9.27,0,0-93.32,43.76-4.62,67.73Z",
    style: {
      fill: "#212c42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.32,574.74s66.42,18.65,118.46,5.67c52.74-13.15,103.67-82.81,103.67-82.81,0,0-68.58,59.31-109.01,70.86-40.43,11.55-113.13,6.27-113.13,6.27Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.41,500.14s46.64,93.4,145.63,81.98c111.38-12.85,134.4-93.25,134.4-93.25,0,0-45.08,54.13-141.71,65.34-56.65,6.57-138.32-54.07-138.32-54.07Z",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.99,517.08s40.64,69.27,119,73.92c79.24,4.71,102.46-36,130.36-63.25-46.26,45.19-87.66,42.12-135.86,42.26-37.36.11-71.6-12.57-113.5-52.93Z",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.96,512.77s56.83,39.12,110.27,43.67c54.16,4.61,124.88-44.84,124.88-44.84,0,0-84.07,33.95-126.07,31.81-41.99-2.14-109.08-30.64-109.08-30.64Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.72,404.29s28.55,100.41,127.95,107.51c111.83,7.98,149.33-66.78,149.33-66.78,0,0-54.31,44.86-151.35,37.99-56.88-4.03-125.93-78.72-125.93-78.72Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.99,540.46s150.29,110.67,297.68,103.65c0,0-179.62,2.27-321.74,91.82,0,0,36.18-109.35,15.55-163.17l8.51-32.3Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.54,750.31s119.37,58.87,66.85,57.71c-52.52-1.16-302.23-20.94-377.81-6.32,0,0,645.02,83.94,863.49,180.66,0,0-61.05-55.12-68.41-81.79,0,0-284.41-138.24-484.12-150.26Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.84,728.79l-18.15,63.21s39.24-3.04,50.24-10.86c11-7.82-13.22-23.09,1.28-29.57,14.5-6.48,33.27-29.37,33.27-29.37l-66.65,6.59Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.95,788.56s-377.33,38.15-511.86,106.97c0,0-37.9-.46,27.61-35.54,65.52-35.08,301.72-71.05,339.32-90.75,37.59-19.7-108.82,22.54-117.72,9.11-8.9-13.42,158.75-53.55,287.53-44.41l-24.89,54.62Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.19,707.83s110.13,87.98,203.3,97.92c120.06,12.81,152.32-4.26,152.32-4.26,0,0-339.87-106.02-365-102.77",
    style: {
      fill: "#223654",
      opacity: 0.72
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.66,781.95s.2-31.28,25.14-45.27c0,0,269.79,32.57,294.79,44.08,0,0-293.93-10.43-319.94,1.19Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.15,875.53s-326.88,71.61-361.9,134.66c0,0-26.62-.28-13.13-14.89,13.49-14.61,86.98-92.6,365.59-135.86l86.83-2.69-77.38,18.78Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,1056.68s342.47-133.21,742.57-122.19c400.1,11.02,789.6,128.34,789.6,128.34,0,0-425.59-198.04-821.7-191.48-396.11,6.57-710.47,185.33-710.47,185.33Z",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,547.78s-92.2-286.93-101.38-307.48c-9.19-20.55-23.9-47.39-23.9-47.39l-13.49,1.32,97.55,356.8s129.63,67.25,145.81,69.5l-104.59-72.75Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.08,490.54s122.47-282.14,120.99-364.34c0,0-3.46-12.67-18.22.15,0,0-26.56,234.93-129.75,355.09,0,0-33.42,39.62-46.64,45.53l73.62-36.43Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.55,490.24s-50.83,121.12-46.63,215.43c-49.78-18.3-94.31-32.41-133.6-43.25l-6.06-2.21s145.14-89.3,139.77-151.32c-5.36-62.02,82.89-328.16,82.89-328.16l20.52-20.28c3.61,2.33,7.23,5.6,10.61,10.14,0,0-73.79,185.71-67.5,319.65Z",
    style: {
      fill: "#a3ea2a",
      opacity: 0.43
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.85,516.85s103.12-246.82,111.9-329.51c8.78-82.69,0,0,0,0,0,0,82.22,235.13,149.41,266.08l-25.19,6.18s-117.36-143.2-120.79-207.73c0,0-45.36,160.02-100.01,270.83l-15.32-5.86Z",
    style: {
      fill: "#2e4463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.67,627.51s227.74,72.95,267.29,99.78c39.55,26.84,96.43,91.94,96.43,91.94,0,0,14.31-5.11,10.27-23.77-4.04-18.67-62.31-73.17-131.14-103.87-68.83-30.7-242.85-64.07-242.85-64.07Z",
    style: {
      fill: "#223654"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.fbe7f15497568d5f8bd2c081c3e9ba6e.svg";
export { ForwardRef as ReactComponent };